import React from 'react';
import { Link } from 'react-router-dom';

import styles from './MobileHeader.module.css';

const Header = () => (
  <div className={styles.container}>
    <div className={styles.separator} />
    <h1>Checkout</h1>
    <Link
      to="/shop"
      style={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <i className="fal fa-times" />
    </Link>
  </div>
);

export default Header;
